module.exports = {
      id: "astrology-usage",
      viewBox: "0 0 29.4 29.4",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#astrology",
      toString: function () {
        return this.url;
      }
    }